'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isLogin = exports.validUserField = exports.logout = exports.login = exports.register = exports.requestRegister = undefined;

var _crypto = require('../utils/crypto');

var _actions = require('../utils/actions');

var registerTypes = ['email', 'phone'];
var requestRegister = exports.requestRegister = function requestRegister(verifyBy, data) {
  if (!registerTypes.includes(verifyBy)) {
    throw new Error('requestRegister: verifyBy ' + verifyBy + ' is invalid.');
  }
  return {
    args: { verifyBy: verifyBy, data: data },
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('requestRegister'),
    minselfAPICall: function minselfAPICall(client) {
      return client.post(_actions.apiPrefix + '/user/registerReq', {
        body: { verifyBy: verifyBy, data: data }
      });
    }
  };
};

var register = exports.register = function register(verify, username, pass) {
  var password = (0, _crypto.sha512)(pass);
  return {
    args: { verify: verify, username: username, password: password },
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('register'),
    minselfAPICall: function minselfAPICall(client) {
      return client.post(_actions.apiPrefix + '/user/register', {
        body: { verify: verify, username: username, password: password }
      });
    }
  };
};

var loginTypes = ['email', 'phone', 'username'];
var login = exports.login = function login(loginBy, account, pass) {
  if (!loginTypes.includes(loginBy)) {
    throw new Error('requestRegister: loginBy ' + loginBy + ' is invalid.');
  }
  var password = (0, _crypto.sha512)(pass);
  return {
    args: { loginBy: loginBy, account: account, password: password },
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('login'),
    minselfAPICall: function minselfAPICall(client) {
      return client.post(_actions.apiPrefix + '/user/login', {
        body: { loginBy: loginBy, account: account, password: password }
      });
    }
  };
};

var logout = exports.logout = function logout() {
  return {
    args: {},
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('logout'),
    minselfAPICall: function minselfAPICall(client) {
      return client.post(_actions.apiPrefix + '/user/logout');
    }
  };
};

var validTypes = ['username', 'email', 'phone', 'regVerify'];
var validUserField = exports.validUserField = function validUserField(type, data) {
  if (!validTypes.includes(type)) {
    throw new Error('validUserField: type ' + type + ' is invalid.');
  }
  return {
    args: { type: type, data: data },
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('validUserField'),
    minselfAPICall: function minselfAPICall(client) {
      return client.get(_actions.apiPrefix + '/user/isValid', {
        q: { type: type, data: data }
      });
    }
  };
};

var isLogin = exports.isLogin = function isLogin() {
  return {
    args: {},
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('isLogin'),
    minselfAPICall: function minselfAPICall(client) {
      return client.get(_actions.apiPrefix + '/user/isLogin');
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/mindself-api-client/lib/actions/user.js
// module id = 510
// module chunks = 1